import { useNavigate } from "react-router-dom";

const COLS = [
  {
    title: "Събития",
    links: [
      { label: "Варна 2027", href: "/varna-2027" },
      { label: "София — очаквайте скоро", href: "/#events" },
      { label: "Пловдив — очаквайте скоро", href: "/#events" },
      { label: "Архив: Варна 2026", href: "/varna-2026" },
    ],
  },
  {
    title: "Платформата",
    links: [
      { label: "За нас", href: "/#about" },
      { label: "Галерия", href: "/#gallery" },
      { label: "Партньори", href: "/partners" },
    ],
  },
];

export default function NationalFooter() {
  const navigate = useNavigate();

  const go = (href) => {
    if (href.startsWith("/#")) {
      navigate("/");
      setTimeout(() => document.getElementById(href.slice(2))?.scrollIntoView({ behavior: "smooth" }), 300);
    } else {
      navigate(href);
      window.scrollTo({ top: 0 });
    }
  };

  return (
    <footer data-testid="national-footer" className="relative bg-[#050d1e] text-[#F5EBD9] pt-20 pb-28 lg:pb-12 border-t border-[#1E3A63]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-6">
            <div className="font-display uppercase text-2xl tracking-tight mb-4">
              Играта <span className="text-[#F5892E]">на</span> Имотите
            </div>
            <p className="text-[#8A9EB8] text-sm leading-relaxed max-w-[44ch]">
              Националните събития за недвижими имоти в България. София · Пловдив · Варна.
            </p>
            <div className="mt-5 font-mono text-[10px] uppercase tracking-[0.26em] text-[#8A9EB8]">
              Следващо събитие: Варна · 23.10.2027
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F5892E] mb-4">
                {col.title}
              </div>
              <div className="space-y-2.5">
                {col.links.map((l) => (
                  <button
                    key={l.label}
                    onClick={() => go(l.href)}
                    className="block text-sm text-[#C8D4E6] hover:text-[#F5892E] transition-colors text-left"
                  >
                    {l.label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-[#1E3A63] flex flex-col sm:flex-row items-center justify-between gap-4 text-[#8A9EB8] text-xs">
          <div>© {new Date().getFullYear()} Играта на Имотите. Всички права запазени.</div>
          <div className="font-mono uppercase tracking-[0.2em]">Организатор: Иво Димовски</div>
        </div>
      </div>
    </footer>
  );
}
